import actions from '../actions/parameters';

export const getApplicationParameters = async (reqBody) => {
  return actions.getApplicationParameters(reqBody);
};

export const putApplicationParameter = async (reqBody) => {
  return actions.putApplicationParameter(reqBody);
};

export const getApplicationDetailParameters = async (reqBody) => {
  return actions.getApplicationDetailParameters(reqBody);
};

export const putApplicationDetailParameter = async (payload, id, type) => {
  return actions.putApplicationDetailParameter(payload, id, type);
};

export const deleteApplicationDetailParameter = async (payload) => {
  return actions.deleteApplicationDetailParameter(payload);
};

export const addApplicationDetailParameter = async (reqBody) => {
  return actions.addApplicationDetailParameter(reqBody);
};

export const getScopes = async (reqBody) => {
  return actions.getScopes(reqBody);
};
